import { toastr } from 'react-redux-toastr';
import errorMessage from '../errorMessages/errorMessage_en';
import errorMessage_es from "../errorMessages/errorMessages_es";
import errorMessage_fr from "../errorMessages/errorMessages_fr";
import errorMessage_it from "../errorMessages/errorMessages_it";
import errorMessage_pt from "../errorMessages/errorMessages_pt";
import errorMessage_ar from "../errorMessages/errorMessages_ar";

const errorMessages = {
    'en': errorMessage,
    'en-US': errorMessage,
    'es': errorMessage_es,
    'fr-FR': errorMessage_fr,
    'it-IT': errorMessage_it,
    'pt-PT': errorMessage_pt,
    'ar': errorMessage_ar
};

export const getCookie = (name) => {
    if (typeof window !== 'undefined') {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : 'en';
    }
};

const showToaster = async ({ messageId, toasterType, requestMessage, language }) => {

    const selectedLang = getCookie("lang");
    const messages = errorMessages[selectedLang] || errorMessage;

    const title = await messages(toasterType);
    const result = await messages(messageId, requestMessage);

    toasterType = toasterType == 'alert' ? 'warning' : toasterType

    return toastr[toasterType](title, result);
}
export default showToaster;